import { I18n } from 'react-redux-i18n';
export function getFieldLabel(tradKey) {
  let mandatory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return `${I18n.t(tradKey)}${mandatory ? ' *' : ''}`;
}